import React from "react";

const ScoreboxRound = ({ type, round, team1, team2 }) => {
  const teams = [
    { ...team1, ...round.teamTotals["1"] },
    { ...team2, ...round.teamTotals["2"] },
  ];
  if (!teams[0] || !teams[1]) {
    return null;
  }
  teams[0].players = [];
  teams[1].players = [];

  round.players.forEach((player) => {
    teams[player.fnTeam - 1].players.push(player);
  });

  const getTeamStats = (team) => {
    // D* Name Kills Deaths R1 R2 R3 R4 Rtg LO Note(KOs) Time
    // D* Name Kills Deaths R1 R2 R3 R4 Rtg LO Note(KOs) Time
    // D* Name Kills Deaths TK FT TeKs RPD Rtg LO Note Time
    const totals = {
      stars: 0,
      name: team.fcTeamName,
      gamescore: 0,
      kills: team.fnWins,
      deaths: team.fnLosses,
      teamkills: team.fnTeamKills,
      alive: 0,
      lagouts: team.fnLagout,
      r1: 0,
      r2: 0,
      r3: 0,
      r4: 0,
      rating: 0,
      note: "",
    };
    const getPlayerStats = (player) => {
      const stars =
        (type === "twcd"
          ? player.league_player.fnWBStars
          : player.league_player.fnJavStars) / 10;
      const stat = {
        stars,
        name: player.fcUserName,
        gamescore: 0,
        kills: player.fnWins,
        deaths: player.fnLosses,
        teamkills: 0,
        alive: (player.fnLives - player.fnLosses > 0 ? 1 : 0),
        lagouts: player.fnLagout,
        r1: 0,
        r2: 0,
        r3: 0,
        r4: 0,
        rating: 0,
        resolution: player.fcResolution,
        note: player.fcUserNameKO ? `KO > ${player.fcUserNameKO}` : "",
      };
      totals.stars = " ";

      const stats = [];
      if (type === "twcd") {
        player.ships.forEach((ship) => {
          const shipStats = {
            ...stat,
            gamescore: 0,
            kills: ship.fnWarbirdKill,
            deaths: ship.fnDeaths,
            rating: ship.fnRating !== -1 ? ship.fnRating : 0,
            knockouts: ship.fnKnockOuts,
            r1: ship.fnKillShortRange,
            r2: ship.fnKillNormalRange,
            r3: ship.fnKillLongRange,
            r4: ship.fnKillUltraLongRange,
          };
          shipStats.gamescore = shipStats.kills + (shipStats.kills - shipStats.deaths) + stat.alive + shipStats.knockouts;
          totals.gamescore += shipStats.gamescore;
          totals.r1 += shipStats.r1;
          totals.r2 += shipStats.r2;
          totals.r3 += shipStats.r3;
          totals.r4 += shipStats.r4;
          totals.rating += shipStats.rating;
          stats.push(shipStats);
        });
      } else if (type === "twcj") {
        player.ships.forEach((ship) => {
          const shipStats = {
            ...stat,
            gamescore: 0,
            kills: ship.fnJavelinKill,
            deaths: ship.fnDeaths,
            rating: ship.fnRating !== -1 ? ship.fnRating : 0,
            teamkills: ship.fnJavelinTeamKill,
            knockouts: ship.fnKnockOuts,
            r1: ship.fnKillShortRange,
            r2: ship.fnKillNormalRange,
            r3: ship.fnKillLongRange,
            r4: ship.fnKillUltraLongRange,
          };
          shipStats.gamescore = shipStats.kills + (shipStats.kills - shipStats.deaths) + stat.alive + shipStats.knockouts - shipStats.teamkills;
          totals.gamescore += shipStats.gamescore;
          totals.r1 += shipStats.r1;
          totals.r2 += shipStats.r2;
          totals.r3 += shipStats.r3;
          totals.r4 += shipStats.r4;
          totals.rating += shipStats.rating;
          stats.push(shipStats);
        });
      }
      return stats;
    };
    const rows = team.players.map(getPlayerStats);
    rows.unshift([totals]);
    return rows;
  };

  const getBasingTeamStats = (team) => {
    // D* Name Kills Deaths TK FT TeKs RPD Rtg LO Note Time
    const totals = {
      stars: 0,
      name: team.fcTeamName,
      ship: null,
      kills: team.fnWins,
      deaths: team.fnLosses,
      teamkills: team.fnTeamKills,
      flagtouches: 0,
      terrkills: 0,
      bombs: 0,
      mines: 0,
      repsPerDeath: [],
      bursts: 0,
      kpb: 0,
      bulletsFired: 0,
      kpbkills: 0,
      kpbtotal: 0,
      kpbships: 0,
      rating: 0,
      lagouts: team.fnLagout,
      // note: "",
    };
    const getPlayerStats = (player) => {
      const stat = {
        stars: player.league_player.fnBaseStars,
        name: player.fcUserName,
        ship: 0,
        kills: player.fnWins,
        deaths: player.fnDeaths,
        teamkills: 0,
        flagtouches: 0,
        terrkills: 0,
        repsPerDeath: 0,
        lagouts: player.fnLagout,
        rating: 0,
        resolution: player.fcResolution,
        // note: player.fcUserNameKO ? `KO > ${player.fcUserNameKO}` : "",
      };
      totals.stars += stat.stars;

      const stats = [];
      player.ships.forEach((ship) => {
        const kills =
          ship.fnWarbirdKill +
          ship.fnJavelinKill +
          ship.fnSpiderKill +
          ship.fnTerrierKill +
          ship.fnLancasterKill +
          ship.fnSharkKill;
        let kpb = "";
        if (
          [1, 3, 7].includes(ship.fnShipTypeID) &&
          kills > 0 &&
          ship.fnBulletsFired > 0
        ) {
          kpb = `${Math.round((kills / ship.fnBulletsFired) * 100)}%`;
        }
        let color = "";
        switch (ship.fnShipTypeID) {
          case 2:
            color = "#FB0";
            break;
          case 3:
            color = "#0B0";
            break;
          case 5:
            color = "#B00";
            break;
          case 7:
            color = "#F70";
            break;
          case 8:
            color = "#55B";
            break;
          default:
            color = "#FFF";
            break;
        }
        const shipStats = {
          ...stat,
          color,
          ship: ship.fnShipTypeID,
          kills,
          deaths: ship.fnDeaths,
          teamkills:
            ship.fnWarbirdTeamKill +
            ship.fnJavelinTeamKill +
            ship.fnSpiderTeamKill +
            ship.fnTerrierTeamKill +
            ship.fnLancasterTeamKill +
            ship.fnSharkTeamKill,
          flagtouches: ship.fnFlagClaimed,
          terrkills: ship.fnTerrierKill,
          bombs:
            ship.fnShipTypeID === 8 || ship.fnShipTypeID === 2
              ? ship.fnBombsFired
              : "",
          mines:
            ship.fnShipTypeID === 8
              ? ship.fnMinesFired
              : "",
          repsPerDeath:
            ship.fnRepels > 0
              ? Math.round((ship.fnRepels / (ship.fnDeaths || 1)) * 100) / 100
              : null,
          bursts: ship.fnShipTypeID === 5 ? ship.fnBurstsFired : "",
          kpb,
          rating: ship.fnRating !== -1 ? ship.fnRating : 0,
        };
        totals.rating += shipStats.rating;
        totals.flagtouches += shipStats.flagtouches;
        totals.terrkills += shipStats.terrkills;
        totals.bombs += (shipStats.bombs === "" ? 0 : shipStats.bombs);
        totals.mines += (shipStats.mines === "" ? 0 : shipStats.mines);
        if (shipStats.repsPerDeath) {
          totals.repsPerDeath.push(shipStats.repsPerDeath);
        }
        totals.bursts += (shipStats.bursts === "" ? 0 : shipStats.bursts);
        if (shipStats.kpb !== "") {
          totals.bulletsFired += ship.fnBulletsFired;
          totals.kpbkills += kills;
          totals.kpb = `${Math.round((totals.kpbkills / totals.bulletsFired) * 100)}%`;
        }
        stats.push(shipStats);
      });
      return stats;
    };
    const rows = team.players.map(getPlayerStats);
    totals.repsPerDeath =
      Math.round(
        (totals.repsPerDeath.reduce((rpds, rpd) => rpds + rpd, 0) /
          (totals.repsPerDeath.length || 0)) *
          100
      ) / 100;
    if (isNaN(totals.repsPerDeath)) {
      totals.repsPerDeath = "0.00";
    }
    rows.unshift([totals]);
    return rows;
  };

  const getStats = () => {
    // D* Name Kills Deaths TK FT TeKs RPD Rtg LO Note Time
    let header;

    if (type === "twcd") {
      header = [
        { name: "GS", key: "gamescore" },
        { name: "Name", key: "name" },
        { name: "K", key: "kills" },
        { name: "D", key: "deaths" },
        { name: "R1", key: "r1" },
        { name: "R2", key: "r2" },
        { name: "R3", key: "r3" },
        { name: "R4", key: "r4" },
        { name: "Rtg", key: "rating" },
        { name: "LO", key: "lagouts" },
        { name: "RES", key: "resolution" },
        { name: "Note", key: "note" },
      ];
    } else if (type === "twcj") {
      header = [
        { name: "GS", key: "gamescore" },
        { name: "Name", key: "name" },
        { name: "K", key: "kills" },
        { name: "D", key: "deaths" },
        { name: "R1", key: "r1" },
        { name: "R2", key: "r2" },
        { name: "R3", key: "r3" },
        { name: "R4", key: "r4" },
        { name: "TKs", key: "teamkills" },
        { name: "Rtg", key: "rating" },
        { name: "LO", key: "lagouts" },
        { name: "RES", key: "resolution" },
        { name: "Note", key: "note" },
      ];
    } else if (type === "twcb") {
      header = [
        { name: "Name", key: "name" },
        { name: "Ship", key: "ship" },
        { name: "K", key: "kills" },
        { name: "D", key: "deaths" },
        { name: "TKs", key: "teamkills" },
        { name: "FT", key: "flagtouches" },
        { name: "TeKs", key: "terrkills" },
        { name: "BOMBs", key: "bombs" },
        { name: "Mines", key: "mines" },
        { name: "RPD", key: "repsPerDeath" },
        { name: "BURs", key: "bursts" },
        { name: "K/BUL", key: "kpb" },
        { name: "Rtg", key: "rating" },
        { name: "LO", key: "lagouts" },
        { name: "RES", key: "resolution" },
      ];
    }

    const getTeamStatsFn = type === "twcb" ? getBasingTeamStats : getTeamStats;
    const team1stats = getTeamStatsFn(teams[0]);
    const team2stats = getTeamStatsFn(teams[1]);

    return {
      header,
      team1: {
        totals: team1stats.shift(),
        ships: team1stats,
      },
      team2: {
        totals: team2stats.shift(),
        ships: team2stats,
      },
    };
  };

  const stats = getStats();

  const printStats = (statsArr, totals = false) =>
    statsArr.map((ship) => (
      <tr
        className={`scorebox-table--row ${totals ? "totals" : ""}`}
        key={Math.random()}
      >
        {stats.header.map(({ key }) => (
          <td
            className={`scorebox-table--row--stat ${key}`}
            key={Math.random()}
            style={{ color: key === "name" ? ship.color : "inherit" }}
          >
            {ship[key]}
          </td>
        ))}
      </tr>
    ));

  return (
    <div className="scorebox-table">
      <table>
        <thead>
          <tr className="scorebox-table--header">
            {stats.header.map((head) => (
              <th
                className={`scorebox-table--header--stat ${head.key}`}
                key={head.key}
              >
                {head.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {printStats(stats.team1.totals, true)}
          {stats.team1.ships.map((ts) => printStats(ts, false))}
          {printStats(stats.team2.totals, true)}
          {stats.team2.ships.map((ts) => printStats(ts, false))}
        </tbody>
      </table>
    </div>
  );
};

export default ScoreboxRound;



// WEBPACK FOOTER //
// ./src/components/scorebox-round/scorebox-round.js